const pharmacyBlock = {
  orderOnline: 'Einfach online bestellen',
  pickUpOrDeliver: 'Abholen oder liefern lassen',
  messengerServicePossible: 'Botendienst möglich',
  pharmacyServices: 'Unsere Leistungen für Sie!',
}

export default pharmacyBlock
